import { make } from 'vuex-pathify'

const chatTokenPromises = new Map()
const chatTokens = new Map()

const state = () => ({
})

const getters = {
}

const actions = {
  getChatToken ({ state, commit, getters }, booking) {
    if (chatTokens.has(booking.id)) { return chatTokens.get(booking.id) }

    if (chatTokenPromises.has(booking.id)) { return chatTokenPromises.get(booking.id) }

    const tokenPromise = (async () => {
      const response = await booking.fetchChatToken()

      chatTokens.set(booking.id, response)
      return response
    })()

    chatTokenPromises.set(booking.id, tokenPromise)

    return tokenPromise
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations: make.mutations(state),
}
